import React from 'react';
import { Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import clsx from 'clsx';

export interface PageHeaderProps {
    title: React.ReactNode;
    icon?: React.ReactElement;
}

const useStyles = makeStyles(theme => ({
    title: {
        fontWeight: 300,
        lineHeight: `${theme.spacing(6)}px`,
    },
    titleWithIcon: {
        position: 'relative',
        paddingLeft: theme.spacing(8),
    },
    icon: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: theme.palette.secondary.main,
        color: theme.palette.secondary.contrastText,
        width: theme.spacing(6),
        height: theme.spacing(6),
        borderRadius: theme.spacing(6),
        left: 0,
        top: 0,
        position: 'absolute',
        textAlign: 'center',
    },
}));

export const PageHeader: React.FunctionComponent<PageHeaderProps> = props => {
    const { title, icon: PageIcon } = props;
    const classes = useStyles({});

    return (
        <Typography
            component="h1"
            variant="h4"
            className={clsx(classes.title, PageIcon && classes.titleWithIcon)}
        >
            {PageIcon && (
                <div className={classes.icon}>{PageIcon}</div>
            )}
            {title}
        </Typography>
    );
};
